import { atom } from 'recoil'
import { Address } from 'types'

export type companyEditAddress = Address

export const companyEditAddressState = atom({
  key: 'companyEditAddress',
  default: {} as companyEditAddress,
})
